import React, { useState, useEffect } from 'react';
import '../css/animate.css';
import '../css/barvy.css';
import '../css/style.css';
import {motion} from "framer-motion";
import { NavLink } from 'react-router-dom';
import { builder } from '../utils/builderWithLocale';
import { getLocalizedText } from '../utils/textLocalization';

function App() {

    // Get localized text
    const homeText = getLocalizedText('general.home_caps');
    const articlesText = getLocalizedText('general.articles');
    const showButtonText = getLocalizedText('general.show_button');

    const [homeContent, setHomeContent] = useState({"data": []});
    const [novinkyContent, setNovinkyContent] = useState();

    useEffect(() => {
        document.title = getLocalizedText('general.novinky_page_title');
        builder
          .get("home-kola")
          .then((data) => {
            setHomeContent(data);
          })
          .catch((error) => console.error("Error fetching content:", error));
        builder
          .getAll("novinky", {
            cache: true,
            cacheTime: 360
          })
          .then((data) => {
            setNovinkyContent(data);
          })
          .catch((error) => console.error("Error fetching content:", error));
      }, []);

    if (!novinkyContent) {
        return <div></div>;
      }

  return (
    <>
    <motion.div  key="loading"initial={{ opacity: 0 }}animate={{ opacity: 1 }}exit={{ opacity: 0 }}transition={{ duration: 0.3 }}>

    <div className="cesta-novinky" style={{top: "60px"}}>
          <NavLink to="/"><button><span>{homeText}</span></button></NavLink>
          <button className="cesta-active"><span>{articlesText}</span></button>
    </div>

    <section className="text-center scrollto clearfix" style={{marginTop: "60px"}}>
        <div className="row clearfix">

            <div className="section-heading">
                <h3 className={`barlow-semibold ${!homeContent.data.novinkyTitle && 'loading-text'}`}>{homeContent.data.novinkyTitle}</h3>
                <h2 className={`section-title white-title ${!homeContent.data.novinkyDesc && 'loading-text'}`}>{homeContent.data.novinkyDesc || "loading..."}</h2>
            </div>
            <div className="novinky-container">
                {novinkyContent
                    .filter(novinka => novinka.data.title !== 'ignore')
                    .slice(0, 999)
                    .map((novinka, index) => (
                    <NavLink to={`/article/${novinka.data.route}`} key={index}>
                        <div className="novinky-box">
                            <div><img src={novinka.data.image+"?format=webp"} alt="Ridley novinky"/><span>{novinka.data.tag}</span></div>
                            <button><span>{showButtonText}</span></button>
                            <h2>{novinka.data.title}</h2>
                            <p>{novinka.data.description ? 
                              novinka.data.description.replace(/<[^>]*>/g, '').substring(0, 100) + '...' : 
                              ''}
                            </p>
                        </div>
                    </NavLink>
                ))}
            </div>
        </div>
    </section>

    </motion.div>
    </>
  );
}

export default App;